import {EDIT_USER_PROFILE_LIST,UPDATE_EDIT_USER_DETAILS_BY_ID} from "../../../config/adminUrlConfig";
import { ApiService } from "../../../config/apiServices";


export const getEditProfileList = async (
    perPage = 10,
    currentPage = 1,
    search = "",
    selectedDistrictId = "",
    status = ""
) => {
    return ApiService.get(`${EDIT_USER_PROFILE_LIST}?number=${perPage}&page=${currentPage}&search=${search}&district_id=${selectedDistrictId}&status=${status}`);
};

export const updateEditProfileById = async(id)=>{
    return ApiService.get(`${UPDATE_EDIT_USER_DETAILS_BY_ID}${id}`);
}

export const submitEditProfileDecision = async (id, status, comment) => {
    return ApiService.post('/api/admin/updateDetails', {
        id,
        status,
        comment
    });
};